import Api from "../axios"

export const getLeaveRequestsList= async (employeeId, financial_year)=>{
    return await Api.get(`/leave_request_list?employee_id=${employeeId || ""}&financial_year=${financial_year}`);
}